import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mlw-loading',
  imports: [],
  template: ``,
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  @HostBinding('class') @Input() size: 'default' | 'small' | 'smaller' = 'default';
}
